var _g, _defs, _g2, _clipPath, _use, _g3, _clipPath2, _use2, _clipPath3, _use3, _g4, _clipPath4, _use4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    xmlns: "http://www.w3.org/2000/svg",
    height: 28,
    id: "screenshot-9f92727f-8793-80c6-8007-455669133965",
    viewBox: "0 0 28 28",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-9f92727f-8793-80c6-8007-455669133965"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-blur"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-shadows"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-9f92727f-8793-80c6-8007-455669133965"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 27,
    height: 28,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "frame-background"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-9f92727f-8793-80c6-8007-455669133974"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "frame-clip-9f92727f-8793-80c6-8007-455669133974-render-2",
    className: "frame-clip frame-clip-def"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 28,
    height: 27.899999999999636,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "frame-container-wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-blur"
  }, /*#__PURE__*/React.createElement("g", {
    className: "frame-container-shadows"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#frame-clip-9f92727f-8793-80c6-8007-455669133974-render-2)",
    fill: "none"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-9f92727f-8793-80c6-8007-455669133974"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    width: 28,
    height: 27.899999999999636,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "frame-background"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "frame-children"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-9f92727f-8793-80c6-8007-455669133975",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-9f92727f-8793-80c6-8007-455669133975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.100358422938825,
    height: 28,
    x: 0.22547712387768115,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none"
    },
    ry: 0,
    fill: "none",
    rx: 0,
    y: 0.24481429956904321
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    id: "strokes-ffceb23a-24bf-80ec-8007-461ec0579885-9f92727f-8793-80c6-8007-455669133975",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape",
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-3-9f92727f-8793-80c6-8007-455669133975-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-3-9f92727f-8793-80c6-8007-455669133975-0"
  }))), /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 0.22547712387768115,
    y: 0.24481429956904321,
    width: 28.100358422938825,
    height: 28,
    id: "stroke-shape-render-3-9f92727f-8793-80c6-8007-455669133975-0",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(229, 126, 63)",
      strokeOpacity: 1
    }
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-3-9f92727f-8793-80c6-8007-455669133975-0",
    clipPath: "url('#inner-stroke-render-3-9f92727f-8793-80c6-8007-455669133975-0')"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "shape-9f92727f-8793-80c6-8007-455669133976"
  }, /*#__PURE__*/React.createElement("style", null, "#shape-{ .st0{fill:#4487C7;}\r\n\t.st1{fill:none;stroke:#4487C7;stroke-miterlimit:10;} }"))), /*#__PURE__*/React.createElement("g", {
    id: "shape-9f92727f-8793-80c6-8007-455669133977"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-9f92727f-8793-80c6-8007-455669133977"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.275634765625,6.86865234375C13.2720947265625,6.86865234375,12.368896484375,7.27001953125,11.666259765625,7.972412109375C10.9638671875,8.675048828125,10.5623779296875,9.578125,10.5623779296875,10.4814453125C10.5623779296875,12.488525390625,12.2685546875,14.09423828125,14.275634765625,14.09423828125L14.275634765625,14.09423828125C15.279296875,14.09423828125,16.1824951171875,13.69287109375,16.885009765625,12.990234375C17.58740234375,12.287841796875,17.989013671875,11.384765625,17.989013671875,10.4814453125C18.0892333984375,8.47412109375,16.3831787109375,6.86865234375,14.275634765625,6.86865234375Z",
    className: "st0",
    style: {
      fill: "rgb(27, 141, 238)",
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "strokes",
    id: "strokes-ffceb23a-24bf-80ec-8007-461ec059bc29-9f92727f-8793-80c6-8007-455669133977"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-5-9f92727f-8793-80c6-8007-455669133977-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-5-9f92727f-8793-80c6-8007-455669133977-0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14.275634765625,6.86865234375C13.2720947265625,6.86865234375,12.368896484375,7.27001953125,11.666259765625,7.972412109375C10.9638671875,8.675048828125,10.5623779296875,9.578125,10.5623779296875,10.4814453125C10.5623779296875,12.488525390625,12.2685546875,14.09423828125,14.275634765625,14.09423828125L14.275634765625,14.09423828125C15.279296875,14.09423828125,16.1824951171875,13.69287109375,16.885009765625,12.990234375C17.58740234375,12.287841796875,17.989013671875,11.384765625,17.989013671875,10.4814453125C18.0892333984375,8.47412109375,16.3831787109375,6.86865234375,14.275634765625,6.86865234375Z",
    id: "stroke-shape-render-5-9f92727f-8793-80c6-8007-455669133977-0",
    style: {
      fill: "none",
      strokeWidth: 1.8,
      stroke: "rgb(255, 145, 0)",
      strokeOpacity: 1
    }
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-5-9f92727f-8793-80c6-8007-455669133977-0",
    clipPath: "url('#inner-stroke-render-5-9f92727f-8793-80c6-8007-455669133977-0')"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "shape-9f92727f-8793-80c6-8007-455669133978"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-9f92727f-8793-80c6-8007-455669133978"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.189697265625,14.19482421875C17.989013671875,13.993896484375,17.58740234375,13.993896484375,17.286376953125,14.19482421875C17.286376953125,14.19482421875,14.275634765625,16.5029296875,11.56591796875,14.19482421875C11.264892578125,13.993896484375,10.9638671875,13.993896484375,10.6627197265625,14.19482421875C10.5623779296875,14.294921875,7.953125,16.70361328125,7.852783203125,21.42041015625C7.852783203125,21.62109375,7.953125,21.82177734375,8.053466796875,21.92236328125C8.15380859375,22.0224609375,8.3544921875,22.123046875,8.55517578125,22.123046875L19.99609375,22.123046875C20.3974609375,22.123046875,20.6986083984375,21.82177734375,20.6986083984375,21.42041015625C20.6986083984375,21.2197265625,20.7989501953125,16.803955078125,18.189697265625,14.19482421875Z",
    className: "st0",
    style: {
      fill: "rgb(27, 141, 238)",
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "strokes",
    id: "strokes-ffceb23a-24bf-80ec-8007-461ec05a1725-9f92727f-8793-80c6-8007-455669133978"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-6-9f92727f-8793-80c6-8007-455669133978-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-6-9f92727f-8793-80c6-8007-455669133978-0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M18.189697265625,14.19482421875C17.989013671875,13.993896484375,17.58740234375,13.993896484375,17.286376953125,14.19482421875C17.286376953125,14.19482421875,14.275634765625,16.5029296875,11.56591796875,14.19482421875C11.264892578125,13.993896484375,10.9638671875,13.993896484375,10.6627197265625,14.19482421875C10.5623779296875,14.294921875,7.953125,16.70361328125,7.852783203125,21.42041015625C7.852783203125,21.62109375,7.953125,21.82177734375,8.053466796875,21.92236328125C8.15380859375,22.0224609375,8.3544921875,22.123046875,8.55517578125,22.123046875L19.99609375,22.123046875C20.3974609375,22.123046875,20.6986083984375,21.82177734375,20.6986083984375,21.42041015625C20.6986083984375,21.2197265625,20.7989501953125,16.803955078125,18.189697265625,14.19482421875Z",
    id: "stroke-shape-render-6-9f92727f-8793-80c6-8007-455669133978-0",
    style: {
      fill: "none",
      strokeWidth: 1.8,
      stroke: "rgb(255, 145, 0)",
      strokeOpacity: 1
    }
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-6-9f92727f-8793-80c6-8007-455669133978-0",
    clipPath: "url('#inner-stroke-render-6-9f92727f-8793-80c6-8007-455669133978-0')"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "shape-9f92727f-8793-80c6-8007-455669133979"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-9f92727f-8793-80c6-8007-455669133979"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.275656335347094,
    cy: 14.495710356916788,
    rx: 12.845878136200781,
    ry: 12.845878136200554,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    className: "st1"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "strokes",
    id: "strokes-ffceb23a-24bf-80ec-8007-461ec05a9287-9f92727f-8793-80c6-8007-455669133979"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape",
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-7-9f92727f-8793-80c6-8007-455669133979-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-7-9f92727f-8793-80c6-8007-455669133979-0"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.275656335347094,
    cy: 14.495710356916788,
    rx: 12.845878136200781,
    ry: 12.845878136200554,
    id: "stroke-shape-render-7-9f92727f-8793-80c6-8007-455669133979-0",
    style: {
      fill: "none",
      strokeWidth: 2,
      stroke: "rgb(255, 145, 0)",
      strokeOpacity: 1
    }
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-7-9f92727f-8793-80c6-8007-455669133979-0",
    clipPath: "url('#inner-stroke-render-7-9f92727f-8793-80c6-8007-455669133979-0')"
  }))))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignin);
export default __webpack_public_path__ + "static/media/signin.d29c53f7a6e741c18b2d3bb562d0022d.svg";
export { ForwardRef as ReactComponent };